function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 5.49l27.93 25.3v29.14H43.7v-20.8H20.31v20.8H4.08V30.79L32 5.49M32 0L0 29v35h24.37V43.19h15.27V64H64V29L32 0z"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+aG9tZTwvdGl0bGU+PHBhdGggZD0iTTMyLDUuNDlsMjcuOTMsMjUuM1Y1OS45M0g0My43VjM5LjEzSDIwLjMxVjU5LjkzSDQuMDhWMzAuNzlMMzIsNS40OU0zMiwwLDAsMjlWNjRIMjQuMzdWNDMuMTlIMzkuNjRWNjRINjRWMjlMMzIsMFoiLz48L3N2Zz4=";
export { SvgHome as ReactComponent };